import { axios } from '../../../util/axios'

// TODO: change to v4/accounts/my
const ODIN_ENDPOINT = '/v4/me'
const WALLET_ENDPOINT = 'https://wallet-api.olx.com.br/wallet'

export const getAccountInfo = () => axios.get(ODIN_ENDPOINT)
export const getWalletInfo = () => axios.get(WALLET_ENDPOINT)
